import { FileUploadError } from '../enums';
export class FileUploadConstants {
}
FileUploadConstants.UploadValidationErrors = [
    FileUploadError.INVALID_FILE_TYPE,
    FileUploadError.MAX_FILE_COUNT_EXCEEDED,
    FileUploadError.MAX_FILE_NAME_CHARACTER_LIMIT_EXCEEDED,
    FileUploadError.MAX_FILE_SIZE_EXCEEDED,
    FileUploadError.MAX_VIDEO_FILE_SIZE_EXCEEDED,
    FileUploadError.CARRIER_CUSTOM_MESSAGE
];
FileUploadConstants.ThumbnailUploadProgressNotification = false;
export const RC_MODULE_PREFIX = 'FILE_UPLOAD';
//# sourceMappingURL=FileUploadConstants.js.map